// extracted by css-extract-rspack-plugin
export default {"empty":"empty--E4OTAFFv250FRajN"};